import noty from '@/plugins/noty'

export const successNotification = ({ message }) => {
  return noty({
    type: 'success',
    timeout: 5000,
    text: message
  })()
}

export const errorNotification = ({ message }) => {
  return noty({
    type: 'error',
    timeout: 5000,
    text: message
  })()
}



// WEBPACK FOOTER //
// ./src/components/shared/InstantInvite/notifications.js